const KEY = 'YHT_HISDATA'
export const setHotHis = (data) => {
  localStorage.setItem(KEY, JSON.stringify(data))
}
export const getHotHis = () => {
  const data = localStorage.getItem(KEY)
  return data ? JSON.parse(data) : []
}
export const clearHotHis =()=>{
  localStorage.removeItem(KEY)
}